import { Box, Card, CardContent, Typography } from '@mui/material'
import * as React from 'react'

import LoginForm from '../forms/LoginForm'

export default function LoginCard({ title = 'Sign In', afterLogin = () => {} }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        alignItems: 'center',
        p: 2,
      }}
    >
      <Card sx={{ width: '100%', maxWidth: '400px', mt: 4 }}>
        <CardContent>
          <Typography variant="h5" component="h1" gutterBottom>
            {title}
          </Typography>
          <LoginForm afterLogin={afterLogin} />
        </CardContent>
      </Card>
    </Box>
  )
}
